<template>
    <div>
    <div class="dashboard-box stats-box w-full px-2 mb-5" v-if="!ignore_header">
            <v-card
            class="pa-2"
            tile
            >
            <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
                <div class="flex flex-row flex-wrap">
                <div class="w-full lg:w-2/3" style="position: relative;">
                    <strong class="mt-2 text-lg">{{ search.keyword }}</strong>

                    <div v-if="search.properties.business.website" class="website mt-1 text-sm"><a href="search.properties.business.website" target="lr-website-link" style="color: #2477F6 !important;">{{ search.properties.business.website }}</a></div>

                    <div class="clearfix pt-4"></div>

                    <div class="flex flex-row flex-wrap">
                    <div class="w-full lg:w-1/2" style="position: relative;">
                        <div class="mb-2" style="color: #757B89; font-size: 11px;">Address</div>

                        {{ search.properties.business.formatted_address }}
                    </div>

                    <div class="w-full lg:w-1/2" style="position: relative;">
                        <div class="mb-2" style="color: #757B89; font-size: 11px;">Phone</div>

                        {{ search.properties.business.formatted_phone_number }}
                    </div>

                    <div class="w-full lg:w-1/2 pt-5" style="position: relative;">
                        <div class="mb-2" style="color: #757B89; font-size: 11px;">Primary Category</div>

                        {{ ucwords(search.properties.business.types[0].replace(/\_/g, ' ')) }}
                    </div>

                    <div class="w-full lg:w-1/2 pt-5" style="position: relative;">
                        <div class="mb-2" style="color: #757B89; font-size: 11px;">Sub Category</div>

                        {{ ((search.properties.business.types[1]) ? ucwords(search.properties.business.types[1].replace(/\_/g, ' ')) : '-') }}
                    </div>
                    </div>

                    <div class="clearfix"></div>
                </div>

                <div class="lr-seo-audit-photo w-full lg:w-1/3">
                    <div v-if="search.properties.business.photos">
                        <img :src="'https://maps.googleapis.com/maps/api/place/photo?photo_reference=' + search.properties.business.photos[0].photo_reference + '&maxheight=200&key=AIzaSyBqF2vFVUoyeU3la0XVOQSOdkhgAfQdBEs'" />
                    </div>
                </div>
                </div>

                <!-- <v-tabs v-if="!$vuetify.breakpoint.xs" class="-mb-6" v-model="gmb_tab">
                    <v-tab>Top Competitors</v-tab>
                    <v-tab>Summary</v-tab>
                    <v-tab @click="show_grid = true">Grid Search Results</v-tab>
                    <v-tab>Review Analysis</v-tab>
                    <v-tab>Post Analysis</v-tab>
                    <v-tab>GBP Issues</v-tab>
                    <v-tab>Rcommendations <span v-if="search.properties.recommendations.items">({{ search.properties.recommendations.items.length }})</span></v-tab>
                </v-tabs> -->
            </div>
            </v-card>
        </div>

        <div>
            <div v-if="search.properties.summary.grade">
                <div class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                        <v-card
                            class="pa-2 pt-6 pb-6"
                            tile

                            :class="(($vuetify.breakpoint.xs) ? 'pl-3' : '')"
                        >
                        <div class="flex flex-row flex-wrap">
                            <div class="w-full lg:w-1/2" style="position: relative;">
                                <div class="lr-seo-box-left">
                                    <div class="lr-doughnut-wrapper">
                                    <div class="lr-doughnut-title">
                                        {{ search.properties.summary.grade.value }}
                                    </div>
                                        <apexchart type="donut" :options="summaryDoughnut.chartOptions" :series="summaryDoughnut.series" width="200"></apexchart>
                                    </div>
                                </div>

                                <div class="lr-seo-box-right pt-4">
                                    <div class="" style="font-size: 20px; font-weight: bold;">
                                        {{ search.properties.summary.grade.title }}
                                    </div>

                                    <div style="color: #757B89; font-size: 12px;">
                                        {{ search.properties.summary.grade.description }}
                                    </div>
                                </div>

                                <div class="clearfix"></div>
                            </div>

                            <div class="w-full lg:w-1/2" :style="'position: relative; ' + (($vuetify.breakpoint.xs) ? '' : 'border-left: solid 1px rgba(0, 0, 0, 0.1); padding-left: 30px;') + ' '">
                                
                            	 <div class="flex flex-row flex-wrap pt-6">
                    				<div class="dashboard-box stats-box w-full px-2 md:w-1/2 lg:w-1/2 pr-3">
                    					<div style='font-weight: bold; padding-bottom: 10px;'>Business Name</div>

                    					<v-progress-linear height="15" color="green lighten-1" background-color="#ff9eaa" rounded :value="search.properties.summary.business_name.percentage"></v-progress-linear>
                    				</div>

                    				<div class="dashboard-box stats-box w-full px-2 md:w-1/2 lg:w-1/2 pr-3">
                    					<div style='font-weight: bold; padding-bottom: 10px;'>Address</div>

                    					<v-progress-linear height="15" color="green lighten-1" background-color="#ff9eaa" rounded :value="search.properties.summary.address.percentage"></v-progress-linear>
                    				</div>
                    			</div>
                                
                            	 <div class="flex flex-row flex-wrap pt-6">
                    				<div class="dashboard-box stats-box w-full px-2 md:w-1/2 lg:w-1/2 pr-3">
                    					<div style='font-weight: bold; padding-bottom: 10px;'>Zip / Post Code</div>

                    					<v-progress-linear height="15" color="green lighten-1" background-color="#ff9eaa" rounded :value="search.properties.summary.zip.percentage"></v-progress-linear>
                    				</div>

                    				<div class="dashboard-box stats-box w-full px-2 md:w-1/2 lg:w-1/2 pr-3">
                    					<div style='font-weight: bold; padding-bottom: 10px;'>Phone Number</div>

                    					<v-progress-linear height="15" color="green lighten-1" background-color="#ff9eaa" rounded :value="search.properties.summary.phone.percentage"></v-progress-linear>
                    				</div>
                    			</div>

                            </div>
                        </div>
                    </v-card>
                </div>

                <div class="flex flex-row flex-wrap">
                    <div class="dashboard-box stats-box w-full px-2 md:w-1/4 lg:w-1/4 mb-5">
                    <v-card
                        class="pa-2"
                        tile
                    >
                        <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
                        <div class="dashboard-box-title">Found</div>

                        <div class=""><strong class="text-xl">{{ search.properties.summary.found }}</strong></div>
                        
                        <div class="stats-box-icon-bg" style='background: #398cfa;'></div>
                        <div class="stats-box-icon">
                            <i class="mdi mdi-magnify" style="color: #398cfa;"></i>
                        </div>
                        </div>
                    </v-card>
                    </div>

                    <div class="dashboard-box stats-box w-full px-2 md:w-1/4 lg:w-1/4 mb-5">
                    <v-card
                        class="pa-2"
                        tile
                    >
                        <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
                        <div class="dashboard-box-title">Not Found</div>

                        <div class=""><strong class="text-xl">{{ search.properties.summary.not_found }}</strong></div>
                        
                        <div class="stats-box-icon-bg" style='background: #46474a;'></div>
                        <div class="stats-box-icon">
                            <i class="mdi mdi-magnify-minus" style="color: #46474a;"></i>
                        </div>
                        </div>
                    </v-card>
                    </div>

                    <div class="dashboard-box stats-box w-full px-2 md:w-1/4 lg:w-1/4 mb-5">
                    <v-card
                        class="pa-2"
                        tile
                    >
                        <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
                        <div class="dashboard-box-title">Correct</div>

                        <div class=""><strong class="text-xl">{{ search.properties.summary.correct }}</strong></div>
                        
                        <div class="stats-box-icon-bg"></div>
                        <div class="stats-box-icon">
                            <i class="mdi mdi-check"></i>
                        </div>
                        </div>
                    </v-card>
                    </div>

                    <div class="dashboard-box stats-box w-full px-2 md:w-1/4 lg:w-1/4 mb-5">
                    <v-card
                        class="pa-2"
                        tile
                    >
                        <div :class="(($vuetify.breakpoint.xs) ? 'p-1' : 'p-3')">
                        <div class="dashboard-box-title">With NAP Errors</div>

                        <div class=""><strong class="text-xl">{{ search.properties.summary.with_nap_errors }}</strong></div>
                        
                        <div class="stats-box-icon-bg" style='background: #ff3d54;'></div>
                        <div class="stats-box-icon">
                            <i class="mdi mdi-alert-circle" style="color: #ff3d54;"></i>
                        </div>
                        </div>
                    </v-card>
                    </div>
                </div>

                <div style="font-weight: bold; font-size: 16px; color: #273042; padding-left: 10px;">Citations List</div>

                <div class="dashboard-box stats-box w-full px-2 mb-5 mt-3">
                	<v-card
	                        class="pa-2"
	                        tile

	                        :class="(($vuetify.breakpoint.xs) ? 'pl-3' : '')"
	                    >
                		<v-tabs>
                			<v-tab>Found</v-tab>
                			<v-tab>Not Found</v-tab>
                		
                			<v-tab-item>
		                        <v-card
		                            class="pa-2"
		                            tile

		                            :class="(($vuetify.breakpoint.xs) ? 'pl-3' : '')"
		                        >
		                        
		                        	<div>
		                        		<table class="w-full rg-datatable mt-5">
		                                    <thead class="border-b border-gray-100 w-full">
		                                    <tr>
		                                        <th>Site/Directory</th>
		                                        <th>Name</th>
		                                        <th>Address</th>
		                                        <th>Zip/Post</th>
		                                        <th>Phone</th>
		                                        <th>Status</th>
		                                    </tr>
		                                    </thead>
		                                    <tbody class="w-full" style="">
		                                    <tr v-for="(item, index) in search.properties.citations.result.response.results.active" :key="index">
		                                        <td class="">
		                                            {{ item.source }}
		                                        </td>
		                                        <td class="">
		                                            <a :href="item.url" target='citation-item.url' :style="((!item.name_correct) ? 'color: #ff3d54 !important;' : '')">{{ item['business-name'] }}</a>
		                                        </td>
		                                        <td class="">
		                                            <span v-if="item.profile_details" :style="((!item.address_correct) ? 'color: #ff3d54 !important;' : '')">{{ item['profile_details']['address'] }}</span>
		                                        </td>
		                                        <td class="">
		                                            <span v-if="item.profile_details" :style="((!item.zip_correct) ? 'color: #ff3d54 !important;' : '')">{{ item['profile_details']['postcode'] }}</span>
		                                        </td>
		                                        <td class="">
		                                            <span v-if="item.profile_details" :style="((!item.phone_correct) ? 'color: #ff3d54 !important;' : '')">{{ item['profile_details']['contact_telephone'] }}</span>
		                                        </td>
		                                        <td>
		                                        	<div v-if="!item.profile_details" :style="'display: inline-block;'">
		                                        		<v-tooltip top color="primary">
										                  <template v-slot:activator="{ on, attrs }">
										                    <i class="mdi mdi-alert" style="font-size: 16px;"
										                      v-bind="attrs"
										                      v-on="on"
										                    ></i>
										                  </template>
										                  <span>There might be NAP issues, but we could not find your profile info.</span>
										                </v-tooltip>
		                                        	</div>

		                                        	<div v-if="item.profile_details && item.has_nap_errors" :style="'display: inline-block;'">
		                                        		<v-tooltip top color="primary">
										                  <template v-slot:activator="{ on, attrs }">
										                    <i class="mdi mdi-alert" style="font-size: 16px; color: #ff3d54;"
										                      v-bind="attrs"
										                      v-on="on"
										                    ></i>
										                  </template>
										                  <span>NAP issues were found. The following details need to be corrected: {{ item.need_to_fix.join(', ') }} </span>
										                </v-tooltip>
		                                        	</div>
		                                        </td>
		                                    </tr>
		                                    </tbody>
		                                </table>
		                        	</div>
		                    	</v-card>
		                    </v-tab-item>
                		
                			<v-tab-item>
		                        <v-card
		                            class="pa-2"
		                            tile

		                            :class="(($vuetify.breakpoint.xs) ? 'pl-3' : '')"
		                        >
		                        
		                        	<div>
		                        		<table class="w-full rg-datatable mt-5">
		                                    <thead class="border-b border-gray-100 w-full">
		                                    <tr>
		                                        <th>Site/Directory</th>
		                                        <th>Date Identified</th>
		                                        <th>Authority</th>
		                                        <th>Citation Value</th>
		                                        <th>Site Type</th>
		                                        <th>Free/Paid</th>
		                                        <th>Actions</th>
		                                    </tr>
		                                    </thead>
		                                    <tbody class="w-full" style="">
		                                    <tr v-for="(item, index) in search.properties.citations.result.response.results.possible" :key="index">
		                                        <td class="">
		                                            <a :href="'https://www.2findlocal.com/Modules/Biz/bizPhoneLookup.php'" target='url-add-citation'>{{ item.source }}</a>
		                                        </td>
		                                        <td class="">
		                                            {{ item['date-identified'] }}
		                                        </td>
		                                        <td class="">
		                                            {{ item['domain-authority'] }}/100
		                                        </td>
		                                        <td class="">
		                                            {{ item['citation-value'] }}
		                                        </td>
		                                        <td class="">
		                                            {{ item['site-type'] }}
		                                        </td>
		                                        <td class="">
		                                            {{ item['listing-type'] }}
		                                        </td>
		                                        <td>
		                                        	<a :href="'https://www.2findlocal.com/Modules/Biz/bizPhoneLookup.php'" target='url-add-citation'>Add Citation</a>
		                                        </td>
		                                    </tr>
		                                    </tbody>
		                                </table>
		                        	</div>
		                    	</v-card>
		                    </v-tab-item>
		                </v-tabs>
		            </v-card>
                </div>
            </div>
            <div v-else class="pt-3">
                <v-skeleton-loader type="article, article, article, article, article, article"></v-skeleton-loader>
            </div>
        </div>

    </div>
  </template>
  
  
  <script>
  import axios from 'axios'
  import moment from 'moment'
  import $ from 'jquery'
  import ApexCharts from 'apexcharts'
  import VueGauge from "@/views/local-recon/VueGauge";
  
  export default {
    props: ['search', 'ignore_header'],

    components: {
        ApexCharts,
    },

    data () {
        return {
            gmb_tab: 0,

            loaded: false,

            seo_audit_grades: {
                "A+": 100,
                "A": 85,
                "A-": 70,
                "B+": 69,
                "B": 65,
                "B-": 60,
                "C+": 59,
                "C": 55,
                "C-": 50,
                "D+": 49,
                "D": 45,
                "D-": 40,
                "E+": 39,
                "E": 35,
                "E-": 30,
                "F+": 29,
                "F": 20,
                "F-": 10
            },

            summaryDoughnut: {
                series: [0, 0],
                chartOptions: {
                colors:['#2477F6', '#DCE4DC'],
                plotOptions: {
                    pie: {
                    donut: {
                        size: '55%'
                    }
                    }
                },
                chart: {
                    type: 'donut',
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                tooltip: {
                    enabled: false
                }
                }
            },
        }
    },
    methods: {
        ucwords (str) {
            return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
                return $1.toUpperCase();
            });
        },
    
        async runCreated() {
            let self = this

            this.loaded = true;

            if (this.search.properties.summary.grade) {
                this.summaryDoughnut.series = [this.seo_audit_grades[this.search.properties.summary.grade.value], (100 - this.seo_audit_grades[this.search.properties.summary.grade.value])];
            }
        },

        showDuplicates(item) {
        	let html = [];

        	for (var i in item.duplicates) {
        		html.push(item.duplicates[i].url);
        	}

        	return html.join('<br />');
        }
    },
    created() {
        let self = this
        // console.log('search', this.search);

        setTimeout(function() {
            self.runCreated();
        }, 2000);
    }
  }
  </script>